export default "__VITE_ASSET__Bg9D1pnG__"